import React, { type FC } from 'react';
import Link from 'src/components-v2/Inputs/Link/Link';
import styles from './Tag.module.scss';

const Tag: FC<{
  tag: string;
  href: string;
}> = ({ tag, href }) => {
  return (
    <div className={styles.blogPostTagWrapper}>
      <Link href={href}>
        <a className={styles.blogPostTag}>
          <span>{tag}</span>
        </a>
      </Link>
    </div>
  );
};

export default Tag;
